module.exports = __webpack_public_path__ + "img/删除.df8e7b18.svg";